document.addEventListener('DOMContentLoaded', function(){

  // Pikaday
  //pikaday( document.getElementById('pikaDay') );

  // 日付をクリアする
  const dateClearBtn = document.querySelectorAll('.js-dateClearBtn');
  if( dateClearBtn ){
    dateClearBtn.forEach(function(e){
      e.addEventListener('click', function(){
        const getName = this.dataset.clear;
        document.forms[1].elements[getName].value = '';
        this.parentNode.classList.remove('focus-fixed');
      });
    });
  }

  // placeholder
  setPlaceHolder();

  // inputNumOnly（inputChange()）
  inputNumOnly('js-inputChange');

  // 確認（モーダルウィンドウ）を閉じる
  confirmCloseBtn.addEventListener('click', function(){
    modalCloseExec();
  });

  // 内容を送信する
  // submitExecBtn.addEventListener('click', function(){
  //   history.pushState( null, null, '../contact/' );
  //   document.forms[0].submit();
  // });

});


// 確認（モーダルウィンドウ）を閉じるボタン
const confirmCloseBtn = document.getElementById('confirmCloseBtn');

// 内容を送信するボタン
const submitExecBtn = document.getElementById('submitExecBtn');


// body に付与する確認（モーダルウィンドウ）を表示するクラス名
const modalOpenClass = 'confirm-open';

// 確認（モーダルウィンドウ）の要素（内容を書き換える要素）
const modalWindowContents = document.getElementById('modalWindowContents');



/**
***  モーダルウインドウを開く  */
function modalOpenExec( contents )
{
  document.body.classList.add(modalOpenClass);
  modalWindowContents.innerHTML = contents;
}

/**
***  モーダルウインドウを閉じる  */
function modalCloseExec()
{
  document.body.classList.remove(modalOpenClass);
  modalWindowContents.innerHTML = '';
}


/**
***  placeholder  */
function setPlaceHolder()
{
  const placeholderParent = document.querySelectorAll('.placeholder-parent');
  const focusClass = {
    in: 'focus-in',
    fixed: 'focus-fixed'
  }
  for ( let i = 0; i < placeholderParent.length; i++ ) {
    const child = placeholderParent[i].firstElementChild; //最初の子要素

    child.addEventListener('focus', function(event) {
      placeholderParent[i].classList.add(focusClass.in);
    });
    child.addEventListener('blur', function(event) {
      placeholderParent[i].classList.remove(focusClass.in);
      placeholderParent[i].classList.remove(focusClass.fixed);
      if( child.value ){
        placeholderParent[i].classList.add(focusClass.fixed);
      }
    });
  }
}



/**
***  inputNumOnly  */
function inputNumOnly(className)
{
  const elements = document.querySelectorAll( '.' + className );

  if( ! elements ){ return }

  elements.forEach( elm => {
    elm.addEventListener('keyup', changeEvt(elm));
    elm.addEventListener('focus', changeEvt(elm));
  });

  elements.forEach( elm => {
    elm.addEventListener('change', function(){
      const data = this.value;
      const hankaku = data.replace(/[０-９. ]/g,function(s){
        return String.fromCharCode(s.charCodeAt(0)- 65248);
      });
      this.value = hankaku;
    });
  });

  function changeEvt(e){
    let old = e.value;
    let v, str, othverVal, maxVal2;

    return function(){
      v = e.value;
      str = this.value;
      // 全角数字は半角数字へ変換, 数字以外の文字列は削除
      str = str.replace(/[^0-9 ０-９]+/, '');

      e.addEventListener('blur', function(){
        let str = this.value;
        str = str.replace(/[^0-9 ０-９]+/, '');
        this.value = str;
      });

      if (v !== str){
        e.value = str;
      }

      if ( old != v){
        old = v;
      }
    };
  }
}


/**
***  pikaday.config
***  @params id element
*/
const pikaday = ( $_id ) => {

  const newDate = new Date();
  const newDateYear = newDate.getFullYear(); // 一年後
  const newDateMonth = newDate.getMonth();
  const newDateDate = newDate.getDate() + 3;
  const minDate =  new Date( newDateYear, newDateMonth, newDateDate );

  new Pikaday({
    field: $_id,
    format: 'YYYY-M-D',
    showMonthAfterYear: true,
    toString(date, format) {
        const day   = ( '00' + date.getDate()).slice(-2);
        const month = ( '00' + (date.getMonth() + 1) ).slice(-2);
        const year  = date.getFullYear();
        return `${year}-${month}-${day}`;
    },
    minDate: minDate,
    i18n: {
      previousMonth : '前月',
      nextMonth     : '次月',
      months        : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      weekdays      : ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
      weekdaysShort : ['日','月','火','水','木','金','土']
    },
    yearSuffix: '年',
    disableDayFn: function(date) {
      // 日曜日を除外
      if( date.getDay() === 0 ){
        return true
      }

      // 祝日を除外
      const day   = ( '00' + date.getDate()).slice(-2);
      const month = ( '00' + (date.getMonth() + 1) ).slice(-2);
      const year  = date.getFullYear();
      const chkDate = year + '-' + month + '-' + day
      if( holidaysArr.includes(chkDate) ){
        return true
      }
    }
  }); // end of Pikaday
}

// 祝日データを取得する
//
let holidaysArr = [];
// 取得したい JSON がある URL を変数へ代入
let requestURL = 'https://holidays-jp.github.io/api/v1/date.json';
// HTTP リクエストを作成するのに、new を使って XMLHttpRequest から新しいリクエストオブジェクトをつくる
let request = new XMLHttpRequest();
// 新しいリクエストを開始
request.open('GET', requestURL);
// XHR オブジェクトがサーバーから返されるデータを判断
request.responseType = 'json';
// リクエストを送信
request.send();
// リクエストに対するレスポンス (response プロパティから取得できます) を 変数へ代入
request.onload = function(){
  const holidays = request.response;
  Object.keys(holidays).forEach( function(elm){
    holidaysArr.push(elm);
  });
};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
